import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { EASE } from "@/components/Reveal";

const AboutPage = () => (
  <div data-testid="about-page" className="bg-white min-h-screen">
    <Navbar />
    <section className="pt-36 sm:pt-44 pb-24 sm:pb-32 px-5 sm:px-8">
      <div className="mx-auto max-w-[1600px]">
        {/* Header */}
        <div className="border-b border-[var(--cerra-border)] pb-10 mb-16">
          <span className="text-[var(--orange)] text-xs font-bold uppercase tracking-[0.28em]">
            ✦ Our Story
          </span>
          <h1 className="mt-5 font-head text-4xl sm:text-6xl lg:text-7xl font-medium uppercase kern-tight leading-none">
            Research &amp; Development Philosophy.
          </h1>
        </div>

        {/* Body copy */}
        <div className="grid lg:grid-cols-12 gap-y-10 gap-x-10 max-w-6xl">
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: EASE }}
            className="lg:col-span-6 font-head text-xl sm:text-2xl font-medium leading-snug kern-tight"
          >
            A Melbourne-based studio founded in 1994, dedicated to crafting
            bespoke automotive designs that blend traditional craftsmanship with
            modern engineering.
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: EASE, delay: 0.1 }}
            className="lg:col-span-6 text-base sm:text-lg leading-relaxed text-black/60"
          >
            With foundations in industrial design and experience at major
            automotive brands, Cerra Design explores the passion for sculptural
            form and performance. The studio emphasizes customer desires and
            experiences as a core part of its creative process, using it to shape
            and refine designs before transitioning to advanced fabrication.
          </motion.p>
        </div>

        {/* Three images */}
        <div className="mt-20 grid grid-cols-1 sm:grid-cols-3 gap-6">
          {[0, 1, 2].map((i) => {
            const imgs = ["/about-1.png", "/about-2.jpg", "/about-3.webp"];
            const src = imgs[i];
            return (
            <motion.div
              key={i}
              data-testid={`about-image-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: EASE, delay: i * 0.1 }}
              className="relative overflow-hidden aspect-[4/3] bg-neutral-100 border border-[var(--cerra-border)] flex items-center justify-center"
            >
              {src ? (
                <img
                  src={src}
                  alt="Cerra Design studio"
                  className="absolute inset-0 h-full w-full object-cover"
                />
              ) : (
                <span className="text-[10px] font-bold uppercase tracking-[0.28em] text-black/25">
                  Image coming soon
                </span>
              )}
              <span className={`absolute top-4 left-4 font-head text-xs font-medium tracking-widest z-10 ${src ? "text-white/80 mix-blend-difference" : "text-black/40"}`}>
                {String(i + 1).padStart(2, "0")}
              </span>
            </motion.div>
            );
          })}
        </div>
      </div>
    </section>
    <Footer />
  </div>
);

export default AboutPage;
